import router from './router'
import store from './store'
//import {Message} from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css'// progress bar style
import { setTimeout } from 'core-js'

NProgress.configure({showSpinner: false})// NProgress Configuration

router.beforeEach((to, from, next) => {
    // 如果跳转404，打印出找不到的路由，方便定位问题
    if (to.path === '/404') {
        console.log(`Path[${to.redirectedFrom}] not found.`)
    }
    NProgress.start() // start progress bar
    if (!store.getters.isHomeInit) { // 判断当前用户空间信息没有初始化，则初始化
        console.log('init tenant')
        setTimeout(() => {
            store.dispatch('InitTenantList').then((tenantList)=>{
                if(store.getters.currentTenant) {
                    store.dispatch("SetCurrentTenant", {tenantId: store.getters.currentTenant, productKey: store.getters.currentProductKey}).then(()=>{
                        loadRouter(to, next)
                    })
                    let tenantAvatar = tenantList.filter(t=>t.tenantId == store.getters.currentTenant)[0].tenantAvatar
                    store.dispatch("ChangeTenantAvator", tenantAvatar).then()
                } else {
                    loadRouter(to, next)
                }
            })
        }, 1000)
        
    } else {
        next()
    }
})

function loadRouter(to, next) {
    console.log('init permission')
    store.dispatch('GetHavePermissions').then(res => { // 拉取 权限
        console.log('userAccount: ', res.userAccount);
        // 用户的权限列表
        const permissions = res.haveOperationList;
        // 根据权限生成可访问的路由表
        store.dispatch('GenerateRoutes',{permissions}).then(() => {
            router.addRoutes(store.getters.addRouters) // 动态添加可访问路由表

            //初始化WebSocket连接
            store.dispatch('InitConnect').then(() => {
                console.log('init websocket connect to ' + res.userAccount)
            }).catch((err) => {
                console.error('init websocket connect failed.', err)
               // Message.error(err || 'init websocket connect failed.')
            })
            next({...to, replace: true}) // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
        })
        // 初始化菜单
        console.log('init sitemap start...')
        store.dispatch('InitSitemap').then(() => {
            console.log('init sitemap end...')
        }).catch((err) => {
            console.error('init sitemap failed...', err)
           // Message.error(err || 'init sitemap failed.')
        })
    }).catch((err) => {
        store.dispatch('FedLogOut').then(() => {
            //Message.error(err || 'Check failed, please later retry')
            console.error('Security service off line...', err)
        })
    })
}

router.afterEach(() => {
    NProgress.done() // finish progress bar
})
